import { render, staticRenderFns } from "./PageSideContainer.vue?vue&type=template&id=3b3b5955&scoped=true&functional=true&"
import script from "./PageSideContainer.vue?vue&type=script&lang=ts&"
export * from "./PageSideContainer.vue?vue&type=script&lang=ts&"
import style0 from "./PageSideContainer.vue?vue&type=style&index=0&id=3b3b5955&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3b3b5955",
  null
  
)

export default component.exports